import React, { useRef } from "react";
import ct from "class-types.macro";
import { BannerType } from "../definitions";
import ProductInfo from "../ProductInfo";
import Header from "../Header";
import useIsMounted from "~/common/useIsMounted";
import { User } from "~/common/Store/models/User";
import { SpotlightBannerItem } from "../../../ProductDetailPageResult";
import { useCtrImpressionTracking } from "../../../../analytics/ClickThroughRateTracking/useCtrImpressionTracking";

interface Props {
  items: readonly SpotlightBannerItem[];
  bannerType: BannerType;
  user: User;
  originalLinkingItemNumber: string;
}

const DoubleProduct = ({
  items,
  bannerType,
  user,
  originalLinkingItemNumber,
}: Props) => {
  const isMounted = useIsMounted();

  const bothItemNumbers = `${items[0]?.itemNumber}:${items[1]?.itemNumber}`;

  const ctrProps = {
    source: originalLinkingItemNumber,
    destination: bothItemNumbers,
    type: bannerType,
  };

  const productRef = useRef<HTMLDivElement>(null);

  useCtrImpressionTracking(productRef, ctrProps);

  return (
    <>
      <Header bannerMessage="Looking for an upgrade?" />
      <div
        className={ct("flex", "justify-between", "overflow-x-auto", "w-full")}
        ref={productRef}
      >
        {items.map(
          (item, index) =>
            index < 2 && (
              <ProductInfo
                originalLinkingItemNumber={originalLinkingItemNumber}
                doubleProductItemNumbers={bothItemNumbers}
                key={item.itemNumber}
                item={item}
                bannerType={bannerType}
                mounted={isMounted}
                user={user}
                displayDoubleProductBorder={!!index}
              />
            ),
        )}
      </div>
    </>
  );
};

export default DoubleProduct;
